import { useRef, useState } from "react";

const STORAGE_KEY = "fotosReveladas2026";

const loadRevealed = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
};

const photos = [
  { src: "/gallery/foto1.jpg", label: "Nosso primeiro encontro", analog: true },
  { src: "/gallery/foto2.png", label: "Natal 2024", analog: true },
  { src: "/gallery/foto3.jpg", label: "O pedido", analog: false },
  { src: "/gallery/foto4.jpg", label: "Simplesmente felizes", analog: true },
];

function Gallery() {
  const [revealed, setRevealed] = useState(loadRevealed);
  // fotos já reveladas em visitas anteriores aparecem sem animação
  const initialRevealed = useRef(revealed).current;

  const reveal = (i) =>
    setRevealed((r) => {
      if (r.includes(i)) return r;
      const next = [...r, i];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });

  return (
    <div
      id="gallery"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>Nós</h1>
        <p className="gallery-dict">
          <em>nós</em> · pron. · dois infinitos que se cruzaram. o que acontece quando o amor vira lar e a melhor parte de qualquer dia.
        </p>
        <div className="gallery-grid">
          {photos.map((p, i) => (
            <div key={i} className="gallery-item">
              <div
                className={`gallery-polaroid${
                  revealed.includes(i) ? " revealed" : ""
                }${initialRevealed.includes(i) ? " instant" : ""}`}
                onClick={() => reveal(i)}
              >
                <img
                  src={p.src}
                  alt={p.label}
                  className={`gallery-img${p.analog ? " analog" : ""}`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Gallery;
